import {
  Route,
  Router,
  Switch,
  Redirect
} from 'react-router-dom';
import React from 'react';
// import { useReducer } from 'react';
import createHistory from 'history/createHashHistory';
import App from '../App';
import SubMenuListPage from '../modules/home/SubMenuListPage';
import SearchResultPage from '../modules/home/SearchResultPage';
import QuestionDetailPage from '../modules/home/QuestionDetailPage';
import ProductDynamic from "../modules/product_dynamic/ProductDynamicListPage";

import CONFIG from '../core/config';

const XMHistory: any = createHistory();

export const XMContext: any = React.createContext(null);


export const RootRouter = () => {
  return <Router history={XMHistory}>
    <Switch>
      <Route key="2" path="/product_dynamic" render={() => <ProductDynamic />} />
      <Route key="1" path="/" render={() => <App />} />
    </Switch>
  </Router>
}

const routes = [
  {
    path: '/entry',
    component: SubMenuListPage,
    name: '列表入口页'
  },
  {
    path: '/result',
    component: SearchResultPage,
    name: '搜索结果页'
  },
  {
    path: '/detail',
    component: QuestionDetailPage,
    name: '词条详情页'
  },



]

export const MainRouter = () => {
  return (
    <Switch>
      {
        routes.map(({ path, component }, key) => (
          <Route
            key={key}
            path={path}
            render={() => {
              const Component = component;
              return <Component />
            }}
          />
        ))
      }
      <Route exact path='/' render={() => (<Redirect to='/entry' />)} />
    </Switch>
  );
}